import { Component, Input, Output, EventEmitter } from "@angular/core";
import { ClippingStudioMamItem } from "app/js/src/domain/clipping-studio/clipping-studio-mam-item";

@Component({
  selector: "evrideo-clipping-studio-mam-media-card",
  templateUrl: "./clipping-studio-mam-media-card.component.html",
  styleUrls: ["./clipping-studio-mam-media-card.component.scss"],
})
export class ClippingStudioMamMediaCardComponent {
  @Input() item!: ClippingStudioMamItem;
  @Input() canAddToTimeline = true;
  @Output() addToTimeline = new EventEmitter<ClippingStudioMamItem>();
}
